var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentZoneType)?_c(_vm.renderComponent,{key:_vm.renderComponent,ref:"vpcRef",tag:"component",attrs:{"params":_vm.params}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }